import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "msi-form" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_4 = { class: "msi-content" }
const _hoisted_5 = { class: "header" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 批量打印选中选")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("导出")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("%")
const _hoisted_12 = { class: "dialog-footer" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("确认")

import {ref,nextTick,computed,watch} from 'vue'
import { getCheckRulesPage,addCheckRules,editCheckRules,deleteCheckRules,getCheckRulesOrder} from '@/service/main/check/checkRules';
import { ElMessage, ElMessageBox } from 'element-plus';
import { exportExcel } from "@/utils/exportExcel";
import Pagination from '@/components/Pagination/index.vue'
import print from 'print-js'
import {useStore} from '@/store'
import {formatUtcToData} from '@/utils/formate'
    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
    //盘点类型
    const checkTypeEnum = computed(() => store.state.login.enums.enumCheckType);
    //盘点周期
    const checkCircleEnum = computed(() => store.state.login.enums.enumCycleType)
    //查询
    const formModel = ref({
      OrderNo: '',
      Name: '',
      PageNo: 1,
      PageSize: 10
    });

    //仓库类型列表
    let tableData = ref([]);

    //列表的数据条数
    const totalItems = ref<number>(0);

    //获取菜单列表
    const getTabelData = () => {
      getCheckRulesPage(formModel.value).then(res => {
        console.log(res)
        if(res.code == 200) {
          const {data} = res;
          const result = data;
          tableData.value = result.rows;
          totalItems.value = result.totalRows;
        }else {
          ElMessage.error(`${res.code}:${res.message}`)
        } 
      }).catch(err => {
        console.log(err)
        ElMessage.error(err)
      })
    }

    getTabelData();

    //重置搜索
    const resetForm = () => {
      formModel.value = {
        OrderNo: '',
        Name: '',
        PageNo: 1,
        PageSize: 10
      }
      getTabelData();
    }

    //选中的行
    const checkRows = ref<{id:number}[]>([]);

    // 选择
    const handleSelectionChange = (val: any) => {
      checkRows.value = val;
    }
    //导出
    const handExport = () => {
      let entozh = {
          id: "序号",
          orderNo: "规则序列号",
          name: "规则名称",
          createdTime: "创建时间",
          createdUserName: '创建人',
          rate: '盘点比例',
          cycleName: '盘点周期',
          checkTypeName: '盘点类型'
        };
      exportExcel(checkRows.value, entozh, "xlsx", "仓库类型信息表");
    }

    const printTable = () => {
      print({
        printable: checkRows.value,
        type: 'json',
        properties: [
          { field: 'orderNo', displayName: '规则序列号'},
          { field: 'name', displayName: '规则名称'},
          { field: 'rate', displayName: '盘点比例'},
          { field: 'cycleName', displayName: '盘点周期'},
          { field: 'checkTypeName', displayName: '盘点类型'},
          { field: 'createdTime', displayName: '创建时间'},
          { field: 'createdUserName', displayName: '创建人'},
        ],
        header: '<h3 style="text-align: center;">盘点规则列表</h3>',
        sytle: '.custom-h3 { color: red; }'
      })
    }

    //批量删除
    const handleBatchDelete = () => {
      const handleArr: number[] = [];
      checkRows.value.forEach(item => {
        handleArr.push(item.id);
      })
      const obj = {id: handleArr};
      ElMessageBox.confirm('是否确认删除？','提示',{
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteCheckRules(obj).then((res: any) => {
          if(res?.code === 200) {
            ElMessage.success('删除成功')
            // 刷新列表
            getTabelData()
          }else {
            ElMessage.error(`删除失败${res?.code}:${res.message}`)
          }
        }).catch((err: any) => {
          console.log(err);
          ElMessage.error(`删除失败${err}`)
        })
      }).catch(() =>{
        ElMessage.info('已取消删除')
      })
    }

    //删除
    const deleteRole = (code: string) => {
      ElMessageBox.confirm('是否确认删除？','提示',{
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteCheckRules({orderNo: code}).then((res: any) => {
          if(res?.code === 200) {
            ElMessage.success('删除成功')
            // 刷新列表
            getTabelData()
          }else {
            ElMessage.error(`删除失败${res?.code}:${res.message}`)
          }
        }).catch((err: any) => {
          console.log(err);
          ElMessage.error(`删除失败${err}`)
        })
      }).catch(() =>{
        ElMessage.info('已取消删除')
      })
    }

    //获取规则单号
    const getRulesOrder = () => {
      getCheckRulesOrder().then(res => {
        if(res.code == 200) {
          console.log(res)
          addForm.value.orderNo = res.data;
        }else {
          return ElMessage.error(`获取单盘点规则序列号失败${res.code}:${res.message}`)
        }
      }).catch(err => ElMessage.error(`获取盘点规则单号失败${err}`));
    }

    //窗口类型
    const dialogType = ref('add')

    const dialogVisible = ref(false);

    //操作表单ref
    const dialogRef = ref();

    //打开窗口
    const openDialog  = (type:number,scope: any = {}) => {
      if(type == 1) {
        getRulesOrder()
        dialogType.value = 'add'
      }else {
        dialogType.value = 'edit'
        const {orderNo,name,checkType,rate,cycle,date,frequency} = Object.assign({},scope);
        addForm.value = {orderNo,name,checkType,rate,cycle,date,frequency}
      }
      dialogVisible.value = true;
      nextTick(() => {
        dialogRef.value.clearValidate();
      })
    }
    //添加/编辑
    let addForm = ref({
      orderNo: '',
      name: '',
      checkType: 0,
      rate: '',
      cycle: 0,
      date: new Date(),
      frequency: 1
    })

    //日期选择不能大于当前时间
    const disabledDate = (time: Date) => {
      return  time.getTime() > Date.now();
    }

    //监视盘点类型的值，如果是全盘，盘点比例100
    watch(() => addForm.value.checkType,(val) => {
      if(val == 2) {
        addForm.value.rate = 100;
      }
    })

    // 盘点比例验证
    var validatorRate = (rule:any, value: any, callback: any) => {
        if (!value) {
            callback()
        } else {
            if (value < 0 || value > 100) {
                return callback(new Error("盘点比例必须为0-100之间"));
            } else {
                callback();
            }
        }
    };

    //出入库频次
    var validatorFrequency = (rule:any, value: any, callback: any) => {
        if (!value) {
            callback()
        } else {
            if (value <= 0) {
                return callback(new Error("出入库频次必须大于等于1"));
            } else {
                callback();
            }
        }
    };

    //rules
    const formRules = {
      orderNo: [{required: true,message: '盘点规则号不能为空',trigger: 'blur'}],
      name: [{required: true,message: '规则名称不能为空',trigger: 'blur'}],
      checkType: [{required: true,message: '盘点类型不能为空',trigger: 'blur'}],
      rate: [{required: true,message: '盘点比例不能为空',trigger: 'blur'},{validator: validatorRate,trigger: 'blur'}],
      cycle: [{required: true,message: '盘点周期不能为空',trigger: 'blur'}],
      date: [{required: true,message: '日期不能为空',trigger: 'blur'}],
      frequency: [{required: true,message: '出入库频次不能为空',trigger: 'blur'},{validator: validatorFrequency,trigger: 'blur'}],
    }

    //操作提交
    const confirm = () => {
      dialogRef.value.validate((vali: any) => {
        if(vali) {
          //添加
          if(dialogType.value == 'add') {
            addCheckRules(addForm.value).then(res => {
              if(res.code == 200) {
                ElMessage.success('添加成功');
                getTabelData();
                dialogVisible.value = false;
              }else {
                ElMessage.error(`${res.code}:${res.message}`)
              }
            }).catch(err => {
              console.log(err)
            })
          }else {
            editCheckRules(addForm.value).then(res => {
              if(res.code == 200) {
                ElMessage.success('编辑成功');
                getTabelData();
                dialogVisible.value = false;
              }else {
                ElMessage.error(`${res.code}:${res.message}`)
              }
            }).catch(err => {
              console.log(err)
            })
          }
        }else {
          ElMessage.warning('表单验证失败');
        }
      })
      
    }
  
    //关闭窗口
    const closeDialog = () => {
      addForm.value = {
        orderNo: '',
        name: '',
        checkType: 0,
        rate: 0,
        cycle: 0,
        date: new Date(),
        frequency: 1
      }
    }

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_form, {
        model: formModel.value,
        "label-width": "120px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "规则序列号:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: formModel.value.OrderNo,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formModel.value.OrderNo) = $event)),
                        clearable: "",
                        placeholder: "请输入规则序列号"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "规则名称:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: formModel.value.Name,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formModel.value.Name) = $event)),
                        clearable: "",
                        placeholder: "请输入规则名称"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        icon: "el-icon-search",
                        onClick: getTabelData
                      }, {
                        default: _withCtx(() => [
                          _hoisted_2
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        icon: "el-icon-refresh-right",
                        onClick: resetForm
                      }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, {
            type: "info",
            icon: "iconfont icon-biaoqianguanli",
            plain: "",
            disabled: checkRows.value.length == 0,
            onClick: printTable
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, {
            type: "info",
            plain: "",
            icon: "el-icon-upload2",
            disabled: checkRows.value.length == 0,
            onClick: handExport
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_button, {
            type: "primary",
            icon: "el-icon-plus",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (openDialog(1)))
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(_component_el_table, {
        data: _unref(tableData),
        border: "",
        style: {"width":"100%"},
        onSelectionChange: handleSelectionChange,
        size: "mini"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, { type: "expand" }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_form, {
                "label-position": "left",
                "label-width": "180px",
                inline: "",
                class: "demo-table-expand"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "创建时间" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(scope.row.createdTime), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_form_item, { label: "创建人" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(scope.row.createdUserName), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_form_item, { label: "修改日期" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(scope.row.updatedTime), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_form_item, { label: "修改人" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(scope.row.updatedUserName), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            width: "60",
            type: "selection"
          }),
          _createVNode(_component_el_table_column, {
            label: "序号",
            align: "center",
            width: "60",
            type: "index"
          }),
          _createVNode(_component_el_table_column, {
            label: "规则序列号",
            prop: "orderNo",
            sortable: "",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "规则名称",
            prop: "name",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "盘点比例",
            align: "center",
            "show-overflow-tooltip": ""
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", null, _toDisplayString(scope.row.rate) + "%", 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "盘点周期",
            prop: "cycleName",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "盘点类型",
            prop: "checkTypeName",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "时间",
            prop: "date",
            sortable: "",
            align: "center",
            "show-overflow-tooltip": ""
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(_unref(formatUtcToData)(scope.row.date, 'YYYY-MM-DD')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "频次",
            prop: "frequency",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "操作",
            width: "260px",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                type: "info",
                plain: "",
                size: "small",
                class: "el-icon-edit",
                onClick: ($event: any) => (openDialog(2,scope.row))
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_button, {
                type: "info",
                plain: "",
                size: "small",
                class: "el-icon-delete",
                onClick: ($event: any) => (deleteRole(scope.row.orderNo))
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"]),
      _createVNode(Pagination, {
        total: totalItems.value,
        page: formModel.value.PageNo,
        "onUpdate:page": _cache[3] || (_cache[3] = ($event: any) => ((formModel.value.PageNo) = $event)),
        limit: formModel.value.PageSize,
        "onUpdate:limit": _cache[4] || (_cache[4] = ($event: any) => ((formModel.value.PageSize) = $event)),
        onPagination: getTabelData,
        style: {"margin-top":"20px","text-align":"center"}
      }, null, 8, ["total", "page", "limit"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((dialogVisible).value = $event)),
      title: dialogType.value == 'add' ? '添加盘点规则': '编辑盘点规则',
      width: "50%",
      onClose: closeDialog
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_12, [
          _createVNode(_component_el_button, {
            onClick: _cache[12] || (_cache[12] = ($event: any) => (dialogVisible.value = false))
          }, {
            default: _withCtx(() => [
              _hoisted_13
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: confirm
          }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _unref(addForm),
          "label-width": "120px",
          ref_key: "dialogRef",
          ref: dialogRef,
          rules: formRules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "规则序列号:",
                      prop: "orderNo"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(addForm).orderNo,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(addForm).orderNo) = $event)),
                          clearable: "",
                          disabled: "",
                          placeholder: "请输入仓库类型名称"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "规则名称:",
                      prop: "name"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(addForm).name,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(addForm).name) = $event)),
                          clearable: "",
                          placeholder: "请输入规则名称"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "盘点类型:",
                      prop: "checkType"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _unref(addForm).checkType,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(addForm).checkType) = $event)),
                          placeholder: "请选择盘点类型",
                          size: "large",
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(checkTypeEnum), (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.title,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "盘点比例:",
                      prop: "rate"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(addForm).rate,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(addForm).rate) = $event)),
                          type: "number",
                          disabled: _unref(addForm).checkType == 2,
                          placeholder: "请输入盘点比例"
                        }, {
                          append: _withCtx(() => [
                            _hoisted_11
                          ]),
                          _: 1
                        }, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "盘点周期:",
                      prop: "cycle"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _unref(addForm).cycle,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(addForm).cycle) = $event)),
                          placeholder: "请选择盘点周期",
                          size: "large",
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(checkCircleEnum), (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.title,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _withDirectives(_createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "日期",
                      prop: "date"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _unref(addForm).date,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(addForm).date) = $event)),
                          type: "date",
                          placeholder: "请选择日期",
                          "disabled-date": disabledDate,
                          style: {"width":"100%"}
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, _unref(addForm).checkType != 2]
                ]),
                (_unref(addForm).checkType == 0)
                  ? (_openBlock(), _createBlock(_component_el_col, {
                      key: 0,
                      span: 12
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "频次",
                          prop: "frequency"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _unref(addForm).frequency,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(addForm).frequency) = $event)),
                              type: "number",
                              min: "1",
                              placeholder: "请输入出入库频次"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}
}

})